import { LocalStorage, date } from 'quasar';
import { defineStore } from 'pinia';
import axios from 'axios';
import constants from 'src/lib/constants';

export const useItsMacrosStore = defineStore('itsMacros', {
  state: () => ({
    account: null,
    accessToken: null,
  }),

  actions: {
    async authenticate({ email, password }) {
      const response = await axios.post('https://api.itsmacros.is/api/v1/auth/login', {
        email,
        password,
        device_name: 'lifetrack',
      });

      if (response.status === 200) {
        const { token, data } = response.data;

        this.accessToken = token;
        this.account = data;

        this.storeCredentials({
          accessToken: this.accessToken,
          account: this.account,
        });
      }
    },

    logout() {
      LocalStorage.remove(constants.LOCAL_STORAGE_ITS_MACROS_ACCESS_TOKEN);
      LocalStorage.remove(constants.LOCAL_STORAGE_ITS_MACROS_ACCOUNT);

      this.account = null;
      this.accessToken = null;
    },

    storeCredentials({ accessToken, account }) {
      LocalStorage.set(constants.LOCAL_STORAGE_ITS_MACROS_ACCESS_TOKEN, accessToken);
      LocalStorage.set(constants.LOCAL_STORAGE_ITS_MACROS_ACCOUNT, account);
    },

    loadCredentials() {
      if (LocalStorage.has(constants.LOCAL_STORAGE_ITS_MACROS_ACCESS_TOKEN)) {
        this.account = LocalStorage.getItem(constants.LOCAL_STORAGE_ITS_MACROS_ACCOUNT);
        this.accessToken = LocalStorage.getItem(constants.LOCAL_STORAGE_ITS_MACROS_ACCESS_TOKEN);
      }
    },

    async getDiaries({ dateObj }) {
      if (!this.account) {
        throw new Error('Account not found');
      }

      if (!this.accessToken) {
        throw new Error('No access token set');
      }

      dateObj.setHours(0, 0, 0, 0);
      const dateFrom = dateObj.toISOString();

      dateObj.setHours(23, 59, 59, 999);
      const dateTo = dateObj.toISOString();

      const response = await axios.get(`https://api.itsmacros.is/api/v1/users/${this.account.id}/diaries`, {
        params: {
          date_from: dateFrom,
          date_to: dateTo,
        },
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
        },
      });

      if (response.status === 200) {
        return response.data.data;
      }

      return [];
    },

    async createDiary({ dateObj, totalMacros }) {
      await axios.post(`https://api.itsmacros.is/api/v1/users/${this.account.id}/diaries`, {
        log_date: date.formatDate(dateObj, 'YYYY-MM-DD'),
        carbs_grams: totalMacros.carbs,
        protein_grams: totalMacros.protein,
        fat_grams: totalMacros.fat,
        fiber_grams: totalMacros.fiber,
      }, {
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
        },
      });
    },

    async updateDiary({ diaryId, dateObj, totalMacros }) {
      await axios.put(`https://api.itsmacros.is/api/v1/users/${this.account.id}/diaries/${diaryId}`, {
        log_date: date.formatDate(dateObj, 'YYYY-MM-DD'),
        carbs_grams: totalMacros.carbs,
        protein_grams: totalMacros.protein,
        fat_grams: totalMacros.fat,
        fiber_grams: totalMacros.fiber,

      }, {
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
        },
      });
    },
  },
});
